export default "__VITE_ASSET__d81872cf__"